enum StyleType {
  SQUARE = 'square',
  CIRCLE = 'circle',
}
export default StyleType;
